import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-full w-full overflow-y-auto p-6 bg-slate-50 dark:bg-slate-900/50 flex flex-col gap-6" }
const _hoisted_2 = { class: "bg-card border rounded-lg p-4 shadow-sm flex flex-col gap-4" }
const _hoisted_3 = { class: "flex flex-col gap-2" }
const _hoisted_4 = { class: "flex items-center gap-2 mt-2" }
const _hoisted_5 = { class: "bg-card border rounded-lg p-4 shadow-sm flex flex-col gap-4" }
const _hoisted_6 = { class: "flex items-center justify-between border-b pb-2" }
const _hoisted_7 = { class: "text-xs text-muted-foreground" }
const _hoisted_8 = {
  key: 0,
  class: "text-center text-muted-foreground py-8 border-2 border-dashed rounded-md"
}
const _hoisted_9 = { class: "flex flex-col gap-3" }
const _hoisted_10 = { class: "flex flex-col flex-1 gap-1" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { class: "flex flex-col w-32 gap-1" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "text-sm font-bold p-2 bg-muted-foreground/10 text-muted-foreground flex items-center justify-between border-b shrink-0" }

import { ref, watch } from 'vue'
import { Button } from '@/components/ui/button'
import { PieChart, Plus, Trash2, RefreshCw } from 'lucide-vue-next'
import BaseVisualEditor from './BaseVisualEditor.vue'
import MermaidCodeEditor from './MermaidCodeEditor.vue'
import MermaidLivePreview from './MermaidLivePreview.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'PieEditorDialog',
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const showCode = ref(true)
const copied = ref(false)
const editableCode = ref('')

// Estado visual del Pie Chart
const chartTitle = ref('Mi Gráfico de Pastel')
const showData = ref(false)
const dataPoints = ref([
  { label: 'Categoría A', value: 40 },
  { label: 'Categoría B', value: 35 },
  { label: 'Categoría C', value: 25 },
])

const addDataPoint = () => {
  dataPoints.value.push({ label: `Nueva Categoría ${dataPoints.value.length + 1}`, value: 10 })
}

const removeDataPoint = (index: number) => {
  dataPoints.value.splice(index, 1)
}

// Generar código desde el estado visual
const generateMermaid = () => {
  let code = `pie${showData.value ? ' showData' : ''}\n`
  if (chartTitle.value.trim()) {
    code += `    title ${chartTitle.value.trim()}\n`
  }
  
  dataPoints.value.forEach(point => {
    const safeLabel = point.label.replace(/"/g, '') // Evitar comillas dobles que rompan la sintaxis
    code += `    "${safeLabel}" : ${point.value}\n`
  })
  
  editableCode.value = code
}

// Sincronizar desde código a estado visual
const syncToVisual = () => {
  const code = editableCode.value
  const lines = code.split('\n')
  
  const newPoints: { label: string, value: number }[] = []
  let newTitle = ''
  let newShowData = false
  
  for (const line of lines) {
    const tLine = line.trim()
    if (tLine.startsWith('pie')) {
      if (tLine.includes('showData')) {
        newShowData = true
      }
    } else if (tLine.startsWith('title ')) {
      newTitle = tLine.replace('title ', '').trim()
    } else if (tLine.match(/^"(.+)"\s*:\s*([\d.]+)/)) {
      const match = tLine.match(/^"(.+)"\s*:\s*([\d.]+)/)
      if (match) {
        newPoints.push({
          label: match[1],
          value: parseFloat(match[2])
        })
      }
    }
  }
  
  chartTitle.value = newTitle
  showData.value = newShowData
  if (newPoints.length > 0) {
    dataPoints.value = newPoints
  }
}

// Watchers
watch(() => props.open, (newVal) => {
  if (newVal) {
    const editingCode = localStorage.getItem('editingDiagramCode');
    if (editingCode) {
      setTimeout(() => {
        editableCode.value = editingCode;
        localStorage.removeItem('editingDiagramCode');
        syncToVisual();
      }, 300);
      return;
    }
  }

  if (newVal && !editableCode.value) {
    generateMermaid()
  }
}, { immediate: true })

watch([chartTitle, showData, dataPoints], () => {
  generateMermaid()
}, { deep: true })

const copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(editableCode.value)
    copied.value = true
    setTimeout(() => copied.value = false, 2000)
  } catch (err) {
    console.error('Failed to copy text: ', err)
  }
}

const saveAndClose = () => {
  emit('save', editableCode.value)
  emit('update:open', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseVisualEditor, {
    open: __props.open,
    "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:open', $event))),
    title: "Gráfico de Pastel (Pie Chart)",
    description: "Agrega categorías y valores para generar un gráfico de distribución (pastel) de forma sencilla.",
    showCode: showCode.value,
    "onUpdate:showCode": _cache[4] || (_cache[4] = ($event: any) => (showCode.value = $event)),
    copied: copied.value,
    onCopy: copyToClipboard,
    onSave: saveAndClose
  }, {
    icon: _withCtx(() => [
      _createVNode(_unref(PieChart), { class: "w-5 h-5 text-primary" })
    ]),
    toolbar: _withCtx(() => [
      _createVNode(_unref(Button), {
        size: "sm",
        onClick: addDataPoint
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Plus), { class: "w-4 h-4 mr-2" }),
          _cache[5] || (_cache[5] = _createTextVNode(" Añadir Dato", -1))
        ]),
        _: 1
      })
    ]),
    canvas: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "font-semibold text-lg border-b pb-2" }, "Configuración del Gráfico", -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "text-sm font-medium" }, "Título del Gráfico", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((chartTitle).value = $event)),
              class: "border rounded-md px-3 py-2 bg-background focus:outline-none focus:ring-2 focus:ring-primary",
              placeholder: "Ej. Distribución de Presupuesto"
            }, null, 512), [
              [_vModelText, chartTitle.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "showDataCheck",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showData).value = $event)),
              class: "w-4 h-4 rounded border-gray-300 text-primary focus:ring-primary"
            }, null, 512), [
              [_vModelCheckbox, showData.value]
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              for: "showDataCheck",
              class: "text-sm font-medium cursor-pointer"
            }, "Mostrar valores numéricos en las etiquetas (showData)", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "font-semibold text-lg" }, "Datos (Segmentos)", -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(dataPoints.value.length) + " segmentos", 1)
          ]),
          (dataPoints.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " No hay datos. Haz clic en \"Añadir Dato\". "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataPoints.value, (point, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "flex items-center gap-3 bg-muted/50 p-2 rounded-md border border-transparent hover:border-border transition-colors group"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "text-[10px] uppercase font-bold text-muted-foreground ml-1" }, "Etiqueta (Nombre)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((point.label) = $event),
                    class: "border-b bg-transparent px-2 py-1 text-sm focus:outline-none focus:border-primary font-medium",
                    placeholder: "Ej. Manzanas"
                  }, null, 8, _hoisted_11), [
                    [_vModelText, point.label]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-[10px] uppercase font-bold text-muted-foreground ml-1" }, "Valor", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((point.value) = $event),
                    class: "border-b bg-transparent px-2 py-1 text-sm focus:outline-none focus:border-primary font-mono",
                    placeholder: "0"
                  }, null, 8, _hoisted_13), [
                    [_vModelText, point.value]
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (removeDataPoint(idx)),
                  class: "ml-2 w-8 h-8 rounded-full flex items-center justify-center text-muted-foreground hover:bg-destructive hover:text-white transition-colors",
                  title: "Eliminar dato"
                }, [
                  _createVNode(_unref(Trash2), { class: "w-4 h-4" })
                ], 8, _hoisted_14)
              ]))
            }), 128))
          ]),
          _createVNode(_unref(Button), {
            variant: "outline",
            class: "mt-2 border-dashed",
            onClick: addDataPoint
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Plus), { class: "w-4 h-4 mr-2" }),
              _cache[12] || (_cache[12] = _createTextVNode(" Añadir Nuevo Segmento ", -1))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    "code-panel": _withCtx(() => [
      _createElementVNode("div", _hoisted_15, [
        _cache[14] || (_cache[14] = _createTextVNode(" Mermaid (Sincronizado) ", -1)),
        _createVNode(_unref(Button), {
          size: "sm",
          variant: "default",
          class: "h-7 text-xs",
          onClick: syncToVisual
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(RefreshCw), { class: "w-3 h-3 mr-2" }),
            _cache[13] || (_cache[13] = _createTextVNode(" Sincronizar a Visual ", -1))
          ]),
          _: 1
        })
      ]),
      _createVNode(MermaidCodeEditor, {
        modelValue: editableCode.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editableCode).value = $event)),
        class: "flex-1 min-h-0"
      }, null, 8, ["modelValue"])
    ]),
    "live-preview": _withCtx(() => [
      _createVNode(MermaidLivePreview, { code: editableCode.value }, null, 8, ["code"])
    ]),
    _: 1
  }, 8, ["open", "showCode", "copied"]))
}
}

})